import gql from 'graphql-tag';

export const removeCourseMutation = gql`
  mutation removeCourse($courseId: String!) {
    removeCourse(courseId: $courseId)
  }
`;
